import React from 'react';
import Popup from "reactjs-popup";
import { Button } from 'reactstrap';

class PopupConfirmation extends React.Component {

    render() {
        return (
            <Popup
                trigger={null}
                modal
                closeOnDocumentClick
                open={this.props.open}
                onClose={this.props.onClose}>
                <div>
                    <div style={{ textAlign: 'center' }}>
                        {this.props.errorMessage}<br />
                        <Button onClick={this.props.onClose} type="submit" className='mx-2 cancel-btn' style={{ marginTop: 10, width: 100 }}>OK</Button>
                    </div>
                </div>
            </Popup>);
    }
}

export default PopupConfirmation;